export const sideAllTopicsIcon = (size: number) => (
	<svg width={size} height={size} viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M0 0V18C0 20.2109 1.78906 22 4 22H22C24.2109 22 26 20.2109 26 18V7H20V0H0ZM2 2H18V18C18 18.7305 18.2227 19.4102 18.5625 20H4C2.80859 20 2 19.1914 2 18V2ZM4 4V9H16V4H4ZM6 6H14V7H6V6ZM20 9H24V18C24 19.1914 23.1914 20 22 20C20.8086 20 20 19.1914 20 18V9ZM4 10V12H9V10H4ZM11 10V12H16V10H11ZM4 13V15H9V13H4ZM11 13V15H16V13H11ZM4 16V18H9V16H4ZM11 16V18H16V16H11Z"
			fill="black"
		/>
	</svg>
);
